var map = {
	"./image-product-1-blue.jpg": 4601,
	"./image-product-1-gray.jpg": 6592,
	"./image-product-1-green.jpg": 3589,
	"./image-product-1-red.jpg": 6989,
	"./image-product-1-thumbnail-blue.jpg": 4518,
	"./image-product-1-thumbnail-gray.jpg": 5422,
	"./image-product-1-thumbnail-green.jpg": 1693,
	"./image-product-1-thumbnail-red.jpg": 7207,
	"./image-product-1-thumbnail.jpg": 7299,
	"./image-product-1.jpg": 3490,
	"./image-product-2-blue.jpg": 9349,
	"./image-product-2-gray.jpg": 4392,
	"./image-product-2-green.jpg": 6392,
	"./image-product-2-red.jpg": 8974,
	"./image-product-2-thumbnail-blue.jpg": 150,
	"./image-product-2-thumbnail-gray.jpg": 4419,
	"./image-product-2-thumbnail-green.jpg": 250,
	"./image-product-2-thumbnail-red.jpg": 9811,
	"./image-product-2-thumbnail.jpg": 4152,
	"./image-product-2.jpg": 9557,
	"./image-product-3-blue.jpg": 7489,
	"./image-product-3-gray.jpg": 4955,
	"./image-product-3-green.jpg": 2621,
	"./image-product-3-red.jpg": 4439,
	"./image-product-3-thumbnail-blue.jpg": 1754,
	"./image-product-3-thumbnail-gray.jpg": 1276,
	"./image-product-3-thumbnail-green.jpg": 5111,
	"./image-product-3-thumbnail-red.jpg": 8009,
	"./image-product-3-thumbnail.jpg": 6097,
	"./image-product-3.jpg": 1090,
	"./image-product-4-blue.jpg": 286,
	"./image-product-4-gray.jpg": 8369,
	"./image-product-4-green.jpg": 7964,
	"./image-product-4-red.jpg": 5614,
	"./image-product-4-thumbnail-blue.jpg": 9394,
	"./image-product-4-thumbnail-gray.jpg": 152,
	"./image-product-4-thumbnail-green.jpg": 6016,
	"./image-product-4-thumbnail-red.jpg": 3582,
	"./image-product-4-thumbnail.jpg": 7584,
	"./image-product-4.jpg": 3906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6998;